<template>
  <div id="DeskView" v-if="schoolInfos">
    <div class="deskHeader">
      <h2>欢迎使用 <span>{{qudao ? qudao.qudao_name : '绿萝心理云平台'}}</span></h2>
      <div v-if="errorStuList && flag">
        <div class="alert" v-if="errorStuList.length">
          <img src="@/assets/fill.png" alt="">
          <span>你有{{errorStuList.length}}条待修正学生信息，请尽快处理</span>
          <a @click="href" v-if="roleID === 1">去处理</a>
          <a-tooltip v-else class="showHide">
            <template slot="title">仅限超级管理员使用</template>
            去处理
          </a-tooltip>
          <img style="cursor: pointer;" @click="() => {flag = false}" src="@/assets/close1.png" alt="">
        </div>
      </div>
    </div>
    <div class="main">
      <desk-left-view :teacherAdmin="teacherAdmin"></desk-left-view>
      <desk-right-view :teacherAdmin="teacherAdmin"></desk-right-view>
    </div>
  </div>
</template>

<script>
  const DeskLeftView = () => import('./DeskLeftView')
  const DeskRightView = () => import('./DeskRightView')
  import { mapState, mapActions, mapMutations } from 'vuex'
  // import STUDENTFUN from '@/util/studentFun'
  export default {
    name: 'DeskView',
    data () {
      return {
        flag: true,
        roleID: null,
        qudao: null
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'errorStuList',
        'schoolInfos'
      ])
      // errorTotal () { // 之前导入的学生身份证有误的学生
      //   if (this.schoolInfos) {
      //     return STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyError.length
      //   }
      //   return 0
      // }
    },
    components: {
      DeskLeftView,
      DeskRightView
    },
    methods: {
      ...mapMutations([
        'setSelectKey',
        'setNavNum'
      ]),
      ...mapActions([
        'getErrorStu'
      ]),
      href () {
        this.$router.push('/studentList/amendInfo')
        this.setNavNum(1)
        this.setSelectKey('2')
      }
    },
    async mounted () {
      this.qudao = sessionStorage.getItem('qudao') ? JSON.parse(sessionStorage.getItem('qudao')) : null
      this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
      await this.getErrorStu()
    }
  }
</script>

<style>
  #DeskView {
    width: 100%;
    margin-top: 24px;
  }
  #DeskView .deskHeader {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
  }
  #DeskView h2 {
    color: #333333;
    font-size: 24px;
    margin-bottom: 24px;
    font-weight: bold;
  }
  #DeskView h2 span {
    color: #15A247;
  }
  #DeskView .main {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  #DeskView .deskHeader .alert {
    background: rgba(249,241,226,1);
    border-radius: 4px;
    border: 1px solid rgba(250,226,177,1);
    padding: 9px 17px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  #DeskView .deskHeader .alert span {
    color: #595959;
    font-size: 14px;
    margin-left: 9px;
    margin-right: 16px;
  }
  #DeskView .deskHeader .alert a {
    text-decoration: underline;
  }
  #DeskView .deskHeader .alert img {
    height: auto;
    width: 14px;
  }
  #DeskView .deskHeader .alert img:last-child {
    width: 10px;
    margin-left: 19px;
  }
  #DeskView .deskHeader .showHide {
    color: #BFBFBF!important;
    cursor: pointer;
  }
</style>
